import type { HTMLAttributes } from "react";
import { useHolyModeOptional } from "@/preferences/holy-mode";
import { SacredIcon, type SacredIconName } from "@/components/sacred-icon";
import { cn } from "./cn";

export const Card = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div data-bible-card className={cn("border-border bg-surface rounded-xl border", className)} {...rest} />
);
export const CardHeader = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("border-border-subtle flex items-center justify-between border-b px-5 py-4", className)} {...rest} />
);
type CardTitleProps = HTMLAttributes<HTMLHeadingElement> & { sacredIcon?: SacredIconName };
export const CardTitle = ({ className, sacredIcon = "scroll", children, ...rest }: CardTitleProps) => {
  const { enabled } = useHolyModeOptional();
  return (
    <h2 className={cn("card-title text-foreground text-sm font-semibold", className)} {...rest}>
      {enabled ? <SacredIcon name={sacredIcon} size={19} /> : null}
      <span>{children}</span>
    </h2>
  );
};
export const CardBody = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("p-5", className)} {...rest} />
);
